<template>
  <el-header id="my_header" height="100px">
    <div class="wd_header">
      <span class="header-logo" @click="toHome">WORLD TRIP</span>
      <!-- <router-link style="margin-left:auto" to="/">预订酒店</router-link>
      <router-link class="header_item" to="/user/notifies">站内消息</router-link>
      <router-link class="header_item" to="/user/user_info">会员中心</router-link> -->
      <span style="margin-left:auto" @click="toHome">预订酒店</span>
      <span @click="toNotify" class="header_item">站内消息</span>
      <span class="header_item" @click="toCenter">会员中心</span>
      <span
        class="header_item"
        @click="toCenter"
        v-if="this.$store.state.userInfo"
      >你好, {{user_name}}</span>
      <span v-else @click="toLogin" class="header_item">注册/登录</span>
    </div>
  </el-header>
</template>
<script>
import api from "../../api/apis";
export default {
  name: "my_header",
  data() {
    return {
      user_name: ""
    };
  },
  created() {
    this.initHeader();
  },
  updated() {
    this.initHeader();
  },
  methods: {
    initHeader() {
      if (this.$store.state.userInfo) {
        api.user
          .getUserInfo(this.$store.state.userInfo.userid)
          .then(res => {
            this.user_name = res.data.info.nick_name;
            window.localStorage.setItem("is_partner",res.data.info.is_partner);
            window.localStorage.setItem("u_level",res.data.info.user_level);
            window.localStorage.setItem("u_percent",res.data.info.cashback_percent);
            window.localStorage.setItem("u_mobile_number",res.data.info.mobile_number);
            window.localStorage.setItem("vcc_right",res.data.info.vcc_right);
          })
          .catch(err => {
            if (err.status == "50002") {
              this.$router.replace("/login");
            }
          });
      }
    },
    toCenter() {
      this.$store.commit("changeUIndex", 0);
      this.$router.push("/user/user_info");
    },
    // toTest() {
    //   this.$router.push("/booking");
    // },
    toNotify() {
      this.$store.commit("changeUIndex", 4);
      this.$router.push("/user/notifies");
    },
    // bookHotel() {
    //   this.$router.push("/hotel_list");
    // },
    toLogin() {
      this.$router.push("/login");
    },
    toHome() {
      this.$router.replace("/");
    }
  }
};
</script>
<style scoped>
.el-header {
  min-width: 1400px;
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 999;
  text-align: center;
  padding: 0 105px;
  background: #fff;
  border-bottom: 1px solid #979797;
  
  font-weight: 600;
}
a {
  color: #202020;
  text-decoration: none;
}
a:hover {
  color: #ff5d0e;
}
.header_item {
  margin-left: 60px;
}
.wd_header {
  display: flex;
  align-items: center;
  height: 100%;
}
.wd_header span {
  display: flex;
  align-items: center;
  height: 100%;
}
.wd_header span:not(:first-child):hover {
  color: #ff5d0e;
  cursor: pointer;
}
.header-logo:hover {
  cursor: pointer;
}
.header-logo {
  font-size: 28px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue